import { render, staticRenderFns } from "./NotifCenter.vue?vue&type=template&id=600f3abb&scoped=true&"
import script from "./NotifCenter.vue?vue&type=script&lang=js&"
export * from "./NotifCenter.vue?vue&type=script&lang=js&"
import style0 from "./NotifCenter.vue?vue&type=style&index=0&id=600f3abb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600f3abb",
  null
  
)

component.options.__file = "NotifCenter.vue"
export default component.exports